import { get } from 'lodash'

import { getUUIDv4 } from '@/src/utils/helper'
import { isRasterDatastoreType } from '@constant'

import { LAYER_TYPE } from '../layer'
import { LAYER_ACTION_TYPE } from './type'

export * from './type'
let ACION_SUPPORT = {}
export function setActionSupport(type, action) {
  ACION_SUPPORT[type] = action
}
function checkActionSupportExists(type) {
  return !!ACION_SUPPORT[type]
}
export function callActionSupport(type, ...params) {
  let action = ACION_SUPPORT[type]
  if (action) {
    return action(...params)
  }
}

function isRasterLayerInfo(info) {
  if (!info) {
    return false
  }
  if (isRasterDatastoreType(info)) {
    return true
  }
  const layerType = String(info.type || '').toLowerCase()
  return layerType === 'raster'
}

export function LayerViewCreate(type, layer, readonly, layer_data) {
  if (isRasterLayerInfo(layer && layer.info)) {
    return createNbdsRasterLayer(layer, readonly, layer_data)
  }
  switch (type) {
    case LAYER_TYPE.NBDS_VECTO_LAYER:
      return createNbdsVectorLayer(layer, readonly, layer_data)
    default:
      return createDefaultLayer(layer)
  }
}
function createNbdsLayerBase(layer, layer_data, layerType) {
  let info = layer.info
  let temp = createDefaultLayer({
    id: getUUIDv4(),
    name: info.name,
    data_id: layer.data_id,
    style: layer.style,
    metadata: {
      bounds: info.bounds,
      fields: get(info, 'datastore_detail.fields', []),
    },
  })
  if (layer_data && layer_data.image_urls && layer_data.image_urls[0]) {
    temp.image_url = layer_data.image_urls[0]
  }
  temp.type = layerType
  temp.info = info
  return temp
}
function createNbdsRasterLayer(layer, readonly, layer_data) {
  let temp = createNbdsLayerBase(
    layer,
    layer_data,
    LAYER_TYPE.NBDS_RASTER_LAYER
  )
  temp.disabled_opacity = readonly
  return temp
}
function createNbdsVectorLayer(layer, readonly, layer_data) {
  let temp = createNbdsLayerBase(layer, layer_data, LAYER_TYPE.NBDS_VECTO_LAYER)
  if (checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_TABLE)) {
    temp.menus.push({
      text: 'Danh sách đối tượng',
      click: (layer) => {
        callActionSupport(LAYER_ACTION_TYPE.SHOW_TABLE, layer)
      },
    })
  }
  if (
    !get(temp.info, 'style.metadata.disable_label') &&
    checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_LABEL)
  ) {
    temp.show_label = false
    let menu = {
      text: temp.show_label ? 'Tắt nhãn' : 'Bật nhãn',
      id: LAYER_ACTION_TYPE.SHOW_LABEL,
      click: (layer) => {
        temp.show_label = !temp.show_label
        menu.text = temp.show_label ? 'Tắt nhãn' : 'Bật nhãn'
        callActionSupport(
          LAYER_ACTION_TYPE.SHOW_LABEL,
          layer,
          temp.show_label,
          menu
        )
      },
    }
    temp.menus.push(menu)
  }
  if (!readonly) {
    if (checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_STYLE))
      temp.menus.push({
        text: 'Cài đặt trình bày',
        click: (layer) => {
          callActionSupport(LAYER_ACTION_TYPE.SHOW_STYLE, layer)
        },
      })
    if (checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_STYLE_LABEL))
      temp.menus.push({
        text: 'Cài đặt nhãn',
        click: (layer) => {
          callActionSupport(LAYER_ACTION_TYPE.SHOW_STYLE_LABEL, layer)
        },
      })
    if (checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_FILTER_DATA))
      temp.menus.push({
        text: 'Cài đặt hiển thị dữ liệu',
        click: (layer) => {
          callActionSupport(LAYER_ACTION_TYPE.SHOW_FILTER_DATA, layer)
        },
      })
  }
  temp.disabled_opacity = readonly
  return temp
}
function createDefaultLayer(layer) {
  layer.metadata = Object.assign({}, layer.metadata)
  layer.show = layer.show != null ? layer.show : true
  let temp = {
    id: layer.id,
    name: layer.name,
    show: layer.show,
    opacity: 1,
    menus: [],
    info: layer,
    style: layer.style,
    legend: layer.legend,
    legend_show: false,
    get selected() {
      return layer.selected
    },
    set selected(value) {
      layer.selected = value
    },

    get metadata() {
      return layer.metadata
    },
    set metadata(value) {
      layer.metadata = value
    },

    data_id: layer.data_id,
    get field_geometry() {
      return layer.metadata.field_geometry || 'geometry'
    },
    get field_id() {
      return layer.metadata.field_id || 'id'
    },
  }
  temp.color = '#00725B'

  if (layer.show_group) {
    temp.group = layer.group
  }
  return temp
}
